import { render, staticRenderFns } from "./places-balloon.vue?vue&type=template&id=20f3bc0d"
import script from "./places-balloon.vue?vue&type=script&lang=js"
export * from "./places-balloon.vue?vue&type=script&lang=js"
import style0 from "./places-balloon.vue?vue&type=style&index=0&id=20f3bc0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports